import React, { useEffect, useRef, useState } from 'react';
import { Step1Props } from './types';
import {
  MODAL_CONTENT,
  FORM_GROUP,
  LABEL,
  REQUIRED_BADGE,
  INPUT,
  HELP_TEXT,
  ERROR_MESSAGE,
  BUTTON_GROUP,
  buttonClass,
  WIZARD_TITLE,
  WIZARD_SUBTITLE,
} from './styles';

const Step1BasicInfo: React.FC<Step1Props> = ({
  formData,
  onChange,
  onNext,
  onCancel,
  onDetailedRegistration,
  error,
  isSubmitting = false,
}) => {
  const urlInputRef = useRef<HTMLInputElement>(null);
  const [urlError, setUrlError] = useState<string>('');

  useEffect(() => {
    urlInputRef.current?.focus();
  }, []);

  const validateUrl = (url: string): boolean => {
    if (!url.trim()) {
      setUrlError('URLを入力してください');
      return false;
    }

    try {
      new URL(url);
      setUrlError('');
      return true;
    } catch {
      setUrlError('有効なURLを入力してください');
      return false;
    }
  };

  const handleUrlChange = (url: string) => {
    onChange('url', url);
    if (url.trim()) {
      validateUrl(url);
    } else {
      setUrlError('');
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isSubmitting && validateUrl(formData.url)) {
      onNext();
    }
  };

  // ①: URLのみ必須。サービス名・カテゴリはURLから自動取得して設定する。
  const isValid = formData.url.trim().length > 0 && !urlError;

  return (
    <div className={MODAL_CONTENT}>
      <form onSubmit={handleSubmit}>
        <div className={WIZARD_TITLE}>商品情報を登録</div>
        <p className={WIZARD_SUBTITLE}>
          広告にしたい商品の紹介ページがおすすめです。
        </p>

        {/* URL Input */}
        <div className={FORM_GROUP}>
          <label className={LABEL} htmlFor="product-url">
            商品・サービスのURL <span className={REQUIRED_BADGE}>*</span>
          </label>
          <input
            className={INPUT}
            ref={urlInputRef}
            type="url"
            id="product-url"
            value={formData.url}
            onChange={(e) => handleUrlChange(e.target.value)}
            placeholder="https://example.com/products/item"
          />
          <span className={HELP_TEXT}>
            取得した情報はあとで修正できます。URLがない場合は「URLなしで詳細登録」から、商品名や特徴を入力してください。
          </span>
          {(urlError || error) && (
            <div className={ERROR_MESSAGE}>⚠️ {urlError || error}</div>
          )}
        </div>

        <div className={BUTTON_GROUP}>
          <button className={buttonClass('outline')} type="button" onClick={onCancel}>
            キャンセル
          </button>
          {onDetailedRegistration && (
            <button
              className={buttonClass('outline')}
              type="button"
              onClick={onDetailedRegistration}
            >
              URLなしで詳細登録
            </button>
          )}
          <button
            className={buttonClass('primary')}
            type="submit"
            disabled={!isValid || isSubmitting}
          >
            {isSubmitting ? '登録中...' : '画像の選択へ →'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Step1BasicInfo;
